import CircularProgress from "@material-ui/core/CircularProgress";
import StatProvider, { StatContext } from "context/StatContext";
import { useEffect, useState } from "react";
import './App.scoped.scss';
import StatBlock from "./StatBlock/StatBlock";

export default function App(props) {
    const [isInitialized, setInitialized] = useState(false);

    useEffect(() => {
        setInitialized(true);
    }, []);

    if (!isInitialized) {
        return (
            <div className="flex-col center-flex full-height">
                <div> Logging in .. </div>
                <br />
                <CircularProgress color="secondary" size="32pt" />
            </div >);
    }

    return (
        <StatProvider>
            <div className="flex-col center-flex full-width">
                <h1 className="title">Stat Plaza</h1>
                <div className="full-width container">
                    <StatContext.Consumer>
                        {_ => <StatBlock />}
                    </StatContext.Consumer>
                </div>
            </div>
        </StatProvider>
    );
}